/* components/ui/Avatar.jsx — аватар пользователя: фото (avatar_url) с фолбэком
   на инициалы. При битой картинке (404) автоматически откатывается на инициалы.
   Единый примитив для CRM (ответственный, авторы заметок/истории) и прочих мест. */
import React from 'react';

const { useState, useEffect } = React;

function initialsFrom(label) {
  const s = (label || '').trim();
  if (!s) return '?';
  const parts = s.split(/\s+/).filter(Boolean);
  const a = parts[0] ? parts[0][0] : '';
  const b = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (a + b).toUpperCase() || '?';
}

function Avatar({ src, label, size = 24, className = '', title }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => { setBroken(false); }, [src]);
  const showImg = src && !broken;
  const style = { width: size, height: size, fontSize: Math.max(9, Math.round(size * 0.42)) };
  return (
    <span
      className={'avatar' + (className ? ' ' + className : '')}
      style={style}
      title={title || label || undefined}
      aria-label={label || undefined}
    >
      {showImg
        ? <img src={src} alt="" onError={() => setBroken(true)} />
        : <span className="avatar__fallback">{initialsFrom(label)}</span>}
    </span>
  );
}

export { Avatar, initialsFrom };
